export const flowPaths = [
	// Terms and Conditions is disabled for launch
	// {
	// 	flow: 1,
	// 	url: '/termsAndConditions',
	// },
	{
		flow: 2,
		url: '/confirmClinicLocation',
	},
];
